import { render, staticRenderFns } from "./CobranzaShow.vue?vue&type=template&id=3bc4ff7c"
import script from "./CobranzaShow.vue?vue&type=script&lang=js"
export * from "./CobranzaShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports